<template>
<div class="share-button">
  <p class="share-button__caption">{{ $translate('share') }}</p>

  <button class="share-button__button" @click="share">
    <svg class="share-button__circle" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 90 90">
      <path class="circle__shadow" fill="#000" d="M11.7,15.1C-5.7,38.4-2.7,64.9,14,77.4s48.8,17.5,63.4,0S95.3,20.3,63.9,4.6
        C58.2,1.7,29.1-8.3,11.7,15.1z"/>
      <path fill="#587EE6" stroke="#000" stroke-width="1.5" stroke-miterlimit="10" d="M11.7,15.1C-5.7,38.4-2.7,64.9,14,77.4s48.8,17.5,63.4,0S95.3,20.3,63.9,4.6
        C58.2,1.7,29.1-8.3,11.7,15.1z"/>
    </svg>

    <img src="/assets/svg/share-icon.svg" alt="Share icon button" data-icon>
  </button>

  <a style="display: none" ref="link" href="" download></a>
</div>
</template>

<script>
export default {
  name: 'ButtonShare',

  methods: {
    async share() {
      this.$sendEvent('Share Icon', 'share_your_result');
      let url = '';

      if (this.$inApp) {
        url = await this.$game.generateShareImage();
        const encoded = encodeURIComponent(url);
        window.location.href = `arcade://share?url=${encoded}`;
      } else {
        url = await this.$game.generateShareImage();
        this.$refs.link.href = url;
        this.$refs.link.click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.share-button {
  flex-flow: column nowrap;
  pointer-events: auto;

  &,
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__caption {
    margin-bottom: 5px;
    font-weight: normal;

    @extend %font-small;

    @include mq($until: mobileL) {
      margin-bottom: 12px;
    }
  }

  &__button {
    position: relative;

    .share-button__circle {
      position: relative;
      width: 4.5vw;
      height: 4.5vw;
      min-width: 50px;
      max-width: 90px;
      min-height: 50px;
      max-height: 90px;

      background-color: transparent;
      cursor: pointer;
    }

    img {
      display: block;
      position: absolute;
      top: 45%;
      left: 50%;
      width: 40%;

      transform: translate(-50%, -50%);
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $color-ui;
    border-radius: 50%;
    box-shadow: $button-shadow;

    @extend %grain;
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    &__caption {
      margin-bottom: 18px;
    }

    img {
      margin-top: -6%;
    }
  };

  @include mq($and: $is-not-touch-device) {
    &__bg {
      transition: transform 0.5s $flap;
    }
    &:hover &__bg {
      transform: scale(1.1);
    }
  }
}
</style>
